import { Component } from '@angular/core';
import { AnyoComponent } from 'projects/app-core/src/app/models/AnyoComponent';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { Permissions } from 'projects/app-core/src/auth/models/roles';
import { AnyoPackSubscriptionGridRequest } from '../../../models/packs/AdminPacksSubscriptionGridRequest';
import {
  AnyoPacksSubscriptionResponse,
  TherapyPackSubscriptionSessionDetails,
} from '../../../models/packs/AnyoPacksSubscriptionGridResponse';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterdataService } from '../../../services/masterdata.service';
import {
  AdminChangeAuxTherapistAndCencernRequest,
  AdminTransferTherapistPackSubscriptionRequest,
  PackService,
} from '../../../services/packs.service';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import * as moment from 'moment';
import { GenericMasterData } from '../../../models/masterDataResponse';
import { TherapyPaymentType } from '../../../models/TherapyPlans';
import { DateRange } from 'projects/app-core/src/models/gridRequest';
import { TherapistGridRequest } from '../../../models/therapistGridRequest';
import { TherapistService } from '../../../services/therapist.service';
import { TherapistTable } from '../../../models/therapistGridResponse';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';
import { TimeRangesResponse } from 'projects/admin/src/app/models/timeRangesRequestResponse';

interface CheckboxOptions {
  label: string;
  value: string;
  checked: boolean;
}

import { getFullName } from 'projects/app-core/src/app/utils/utils';
@Component({
  selector: 'app-packs-subscription',
  templateUrl: './packs-subscription.component.html',
  styleUrl: './packs-subscription.component.scss',
})
export class PacksSubscriptionComponent extends AnyoComponent {
  constructor(
    auth: AuthService,
    private toastService: ToastService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private masterdataService: MasterdataService,
    private packService: PackService,
    public utils: UtilsService,
    private therapistService: TherapistService,
  ) {
    super(auth);
  }
  paymentFilterOption: TherapyPaymentType[] = Object.values(TherapyPaymentType);
  paymentTypeCheckBoxOptions: CheckboxOptions[] = [];
  isUserPage: boolean = false;
  pageSizeOptions = [10, 20, 50, 100];
  tableLoading: boolean = false;
  globalSearchInput: string = '';
  page: number = 1;
  pageSize: number = 10;
  totalRecords: number = 0;
  showTest: boolean = false;
  tableData: AnyoPacksSubscriptionResponse[] = [];
  packId: string = '';
  userId: string = '';
  expandSet = new Set<string>();
  selectedSubscription: AnyoPacksSubscriptionResponse | undefined = undefined;
  concernsMasterData: GenericMasterData[] = [];
  paymentType: string[] | undefined = undefined;
  validTillColumnFilterDate: Date[] = [];
  purchasedAtColumnFilterDate: Date[] = [];
  activatedOnDateFilter: DateRange = {} as DateRange;
  validTillDateFilter: DateRange = {} as DateRange;
  isModelVisible: boolean = false;
  packIdToCancel: string = '';
  pack: AnyoPacksSubscriptionResponse | undefined = undefined;
  isModel2Visible = false;
  selectedTherapistType = '';
  selectedOption = '';
  therapistOptions: {
    label: string;
    value: string;
  }[] = [];
  isModel3Visible = false;
  therapistConcernOptions: {
    label: string;
    value: string;
  }[] = [];
  therapistExpertiseOptions: {
    label: string;
    value: string;
  }[] = [];

  selectedSessionDate: Date | undefined;
  selectedSessionTime: Date | undefined;
  checkBoxTimeRangeOptions: { label: string; value: TimeRangesResponse; checked: boolean; disabled: boolean }[] = [];
  sessionOkDisabled = true;

  therapist: TherapistTable[] = [];
  transferConfirmedSessions = false;
  feedbackSessionIds: string[] = [];
  affectedSessions: TherapyPackSubscriptionSessionDetails[] = [];
  isVisibleSendFeedback = false;
  sendFeedbackPack: AnyoPacksSubscriptionResponse | undefined;
  sendFeedbackTherapistOptions: { label: string; value: string }[] = [];
  sendFeedbackDefaultTherapistId: string | undefined;
  showSendFeedbackBtn = false;
  newTherapistEmail = '';
  isWarningModalVisible = false;

  date = '';

  async ready() {
    await this.loadMasterData();
    if (this.user) {
      this.showSendFeedbackBtn =
        this.user.customClaims?.additionalPermissions?.includes(
          Permissions.SendFeedbackToTherapist,
        ) ?? false;
      this.activatedRoute.queryParams.subscribe((value) => {
        if (value) {
          const packId = value['packId'];
          const userId = value['userId'];
          if (packId) {
            this.isUserPage = false;
            this.packId = packId;
          }
          if (userId) {
            this.isUserPage = true;
            this.userId = userId;
          }
        }
      });
      await this.fetchPacksSubscription();
      await this.fetchTherspist();
    }
  }

  async loadMasterData(): Promise<void> {
    this.masterdataService.masterDataList().subscribe({
      next: (masterData) => {
        this.concernsMasterData = masterData.therapyConcerns;
        this.therapistConcernOptions =
          masterData.therapyConcerns?.map((data) => {
            return {
              label: data.data,
              value: data.m_id,
            };
          }) || [];
        this.therapistExpertiseOptions =
          masterData.therapyPackExpertise?.map((data) => {
            return {
              label: data.data,
              value: data.m_id,
            };
          }) || [];
      },
    });
  }

  async fetchPacksSubscription() {
    this.tableLoading = true;
    const req: AnyoPackSubscriptionGridRequest = {
      page: this.page,
      pageSize: this.pageSize,
      filters: {
        TEST_PACK: [this.showTest ? 'true' : 'false'],
        ALL_SESSION_COMPLETED: [],
        PAYMENT_TYPE: [],
        USER_ID: [],
        PACKAGE_ID: [],
        PARTNER_ID: [],
        UNIQUE_USER: [],
      },
      dateFilters: {
        VALID_TILL: {} as DateRange,
        ACTIVETED_ON: {} as DateRange,
      },
      export: false,
    };
    if (this.globalSearchInput) {
      req.globalSearch = [this.globalSearchInput];
    }
    if (this.packId) {
      req.filters!.PACKAGE_ID = [this.packId];
    }
    if (this.userId) {
      req.filters!.USER_ID = [this.userId];
    }
    if (this.paymentType) {
      req.filters!.PAYMENT_TYPE = this.paymentType;
    }
    if (this.validTillColumnFilterDate.length) {
      req.dateFilters!.VALID_TILL = {
        from: this.validTillColumnFilterDate[0],
        to: this.validTillColumnFilterDate[1],
      };
    }
    if (this.purchasedAtColumnFilterDate.length) {
      req.dateFilters!.ACTIVETED_ON = {
        from: this.purchasedAtColumnFilterDate[0],
        to: this.purchasedAtColumnFilterDate[1],
      };
    }
    this.packService.getPacksSubscriptionGrid(req).subscribe({
      next: (res) => {
        this.tableData = res.data;
        this.page = res.pageNum;
        this.pageSize = res.pageSize;
        this.totalRecords = res.totalRecords;
        this.paymentTypeCheckBoxOptions = [];
        this.paymentTypeCheckBoxOptions = this.paymentFilterOption.map(
          (data) => {
            if (this.paymentType?.includes(data)) {
              return {
                label: this.utils.convertToTitleCase(data),
                value: data,
                checked: true,
              };
            } else {
              return {
                label: this.utils.convertToTitleCase(data),
                value: data,
                checked: false,
              };
            }
          },
        );
        this.tableLoading = false;
      },
      error: (err) => {
        console.log(err);
        this.tableLoading = false;
      },
    });
  }
  resetFilter() {
    this.page = 1;
    this.pageSize = 10;
    this.globalSearchInput = '';
    this.paymentType = undefined;
    this.validTillColumnFilterDate = [];
    this.purchasedAtColumnFilterDate = [];
    this.fetchPacksSubscription();
  }
  searchGlobal() {
    this.page = 1;
    this.globalSearchInput = this.globalSearchInput.trim();
    this.fetchPacksSubscription();
  }
  testEventChangeFn($event: boolean) {
    this.showTest = $event;
    this.fetchPacksSubscription();
  }
  nzPageIndexChange($event: number) {
    this.page = $event;
    this.fetchPacksSubscription();
  }
  nzPageSizeChange($event: number) {
    this.pageSize = $event;
    this.fetchPacksSubscription();
  }
  goToFilterUsers(userId: string) {
    window.open(`therapy-plans/subscriptions?userId=${userId}`);
  }

  onExpandChange(
    id: string,
    checked: boolean,
    data: AnyoPacksSubscriptionResponse,
  ) {
    if (checked) {
      this.expandSet.add(id);
      this.selectedSubscription = data;
    } else {
      this.expandSet.delete(id);
      this.selectedSubscription = undefined;
    }
  }
  convertDataAndTime(date: Date) {
    return moment(date).format(' DD/MM/YYYY hh:mm:A ');
  }

  getPrimaryCount(data: TherapyPackSubscriptionSessionDetails[]): number {
    return data.filter((d) => d.primaryTherapist).length;
  }

  getSecondaryCount(data: TherapyPackSubscriptionSessionDetails[]): number {
    return data.filter((d) => d.secondaryTherapist).length;
  }

  getConcernNameById(id: string) {
    const concern = this.concernsMasterData.find((data) => data.m_id === id);
    return concern?.data;
  }

  paymentTypeFilterChangeFn($event: string[]) {
    this.paymentType = $event;
  }
  validTillFilterDateChange($event: Date[]) {
    const startDate = moment($event[0]).startOf('day').toDate();
    const endDate = moment($event[1]).endOf('day').toDate();
    const isToday = moment(startDate).isSame(endDate, 'day');
    this.validTillDateFilter = {
      from: isToday ? moment($event[0]).startOf('day').toDate() : startDate,
      to: isToday ? moment($event[1]).endOf('day').toDate() : endDate,
    };
  }
  purchasedAtFilterDateChange($event: Date[]) {
    const startDate = moment($event[0]).startOf('day').toDate();
    const endDate = moment($event[1]).endOf('day').toDate();
    const isToday = moment(startDate).isSame(endDate, 'day');
    this.activatedOnDateFilter = {
      from: isToday ? moment($event[0]).startOf('day').toDate() : startDate,
      to: isToday ? moment($event[1]).endOf('day').toDate() : endDate,
    };
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onChangeTherapist(data: AnyoPacksSubscriptionResponse) {
    this.isModel2Visible = true;
    this.pack = data;
  }

  async fetchTherspist() {
    const req: TherapistGridRequest = {
      page: 1,
      pageSize: 100,
      export: false,
    };
    this.therapistService.listTherapist(req).subscribe({
      next: (value) => {
        this.therapist = value.data;
      },
      error: () => {
        this.toastService.showAnyoErrorToast('Error while fetching therapist');
      },
    });
  }

  handleCancelSubscription() {
    this.isModelVisible = false;
    this.packService
      .adminDeactivatePackSubscription(this.packIdToCancel)
      .subscribe({
        next: () => {
          this.toastService.showSuccess(
            'Subscription deactivated successfully!',
          );
          this.packIdToCancel = '';
          this.isModelVisible = false;
          this.fetchPacksSubscription();
        },
        error: (err) => {
          console.log(err);
          this.toastService.showError('Something went wrong!');
        },
      });
  }
  onCancelSubscription(id: string) {
    this.isModelVisible = true;
    this.packIdToCancel = id;
    console.log(id);
  }

  computeAffectedConfirmedSessions() {
    if (!this.pack) {
      this.affectedSessions = []
      return;

    }
    const now = moment()
    this.affectedSessions = (this.pack.sessionDetails.filter(
      (d) =>
        (this.selectedTherapistType === 'primary'
          ? d.primaryTherapist
          : d.secondaryTherapist) &&
        d.sessionBooked &&
        d.sessionStatus === 'Confirmed' &&
        d.sessionDate &&
        moment(d.sessionDate).isAfter(now),
    ))
  }
  onTherapistTypeChange(type: string): void {


    this.selectedTherapistType = type;

    this.resetSessionSchedulingState();

    this.computeAffectedConfirmedSessions()

    const options: { label: string; value: string }[] = [];
    const pack = this.tableData.find((d) => d.packId === this.pack!.packId);
    if (type === 'primary') {
      this.therapist.forEach((data) => {
        if (
          data.anyoPackId?.includes(this.pack!.packId) &&
          data.email !== pack!.primaryTherapistDetails.email
        ) {
          options.push({
            label: getFullName(data.firstName, data.lastName),
            value: data.id!,
          });
        }
      });
    } else {
      this.therapist.forEach((data) => {
        if (
          data.packExpertiseDetails?.some(
            (p) => p.packId === this.pack!.packId,
          ) &&
          pack!.auxiliaryTherapistDetails.some((d) => d.email !== data.email)
        ) {
          options.push({
            label: getFullName(data.firstName, data.lastName),
            value: data.id!,
          });
        }
      });
    }
    this.therapistOptions = options;
  }

  resetSessionSchedulingState(): void {
    this.selectedOption = ''
    this.newTherapistEmail = ''
    this.checkBoxTimeRangeOptions = [];
    this.transferConfirmedSessions = false;
    this.selectedSessionDate = undefined;
    this.selectedSessionTime = undefined;
    this.sessionOkDisabled = true;
    this.date = '';
    this.feedbackSessionIds = [];
  }

  onSendFeedback(data: AnyoPacksSubscriptionResponse) {
    this.sendFeedbackPack = data;
    // Offer the pack's own therapists first; fall back to every therapist.
    const packEmails = [
      data.primaryTherapistDetails?.email,
      ...(data.auxiliaryTherapistDetails || []).map((t) => t.email),
    ].filter(Boolean);
    const packTherapists = this.therapist.filter((t) =>
      packEmails.includes(t.email),
    );
    this.sendFeedbackTherapistOptions = (
      packTherapists.length ? packTherapists : this.therapist
    ).map((t) => ({
      label: getFullName(t.firstName, t.lastName),
      value: t.id!,
    }));
    this.sendFeedbackDefaultTherapistId = this.therapist.find(
      (t) => t.email === data.primaryTherapistDetails?.email,
    )?.id;
    this.isVisibleSendFeedback = true;
  }

  onCloseModel2(): void {
    this.isModel2Visible = false
    this.selectedTherapistType = ''
    this.resetSessionSchedulingState()
    this.affectedSessions = []
  }
  handleWarningModalConfirm() {
    this.isWarningModalVisible = false;
    this.onSubmitTransfer()
  }

  handleWarningModalBack() {
    this.isWarningModalVisible = false;
  }
  handleTransferSubscription() {

    if (this.affectedSessions.length > 0 && !this.transferConfirmedSessions) {
      this.isWarningModalVisible = true
      return;
    }
    this.onSubmitTransfer()
  }
  onSubmitTransfer() {
    const selectedSlot = this.checkBoxTimeRangeOptions.find((o) => o.checked)?.value;
    const sessionToReschedule = this.pack?.sessionDetails.find(
      (s) => s.sessionBooked && !s.sessionCompleted,
    ) || this.pack?.sessionDetails.find((s) => !s.sessionCompleted);

    // Calculate rescheduleSlots if a slot is selected
    const rescheduleSlots = selectedSlot && sessionToReschedule && this.selectedSessionDate
      ? (() => {
        const slotDate = moment(this.selectedSessionDate);
        const startMoment = moment(selectedSlot.start, 'hh:mm a');
        const endMoment = moment(selectedSlot.end, 'hh:mm a');
        const startEpoch = slotDate
          .clone()
          .set({
            hour: startMoment.hour(),
            minute: startMoment.minute(),
            second: 0,
            millisecond: 0,
          })
          .format('x');
        const endEpoch = slotDate
          .clone()
          .set({
            hour: endMoment.hour(),
            minute: endMoment.minute(),
            second: 0,
            millisecond: 0,
          })
          .format('x');
        return [{
          sessionId: (sessionToReschedule.sessionId || sessionToReschedule.id!) as string,
          startTime: startEpoch,
          endTime: endEpoch,
        }];
      })()
      : undefined;

    // Only calculate newSessionDateTime if rescheduleSlots is NOT being used
    // and both date and time are selected
    const newSessionDateTime = !rescheduleSlots && this.selectedSessionDate && this.selectedSessionTime
      ? moment(this.selectedSessionDate)
        .set({
          hour: moment(this.selectedSessionTime).hour(),
          minute: moment(this.selectedSessionTime).minute(),
          second: 0,
          millisecond: 0,
        })
        .valueOf()
      : undefined;

    const req: AdminTransferTherapistPackSubscriptionRequest = {
      packSubscriptionId: this.pack!.packSubscriptionId,
      newTherapistId: this.selectedOption,
      expertiseId:
        this.selectedTherapistType === 'primary'
          ? this.pack!.primaryTherapistExpertiseId
          : this.pack!.auxExpertPackExpertise[0].expertiseId,
      transferConfirmedSessions: this.transferConfirmedSessions,
      newSessionDateTime,
      rescheduleSlots,
      feedbackSessionIds: this.feedbackSessionIds,
    };
    this.packService.adminTransferTherapistPackSubscription(req).subscribe({
      next: () => {
        this.toastService.showSuccess('Therapist transfered successfully!');
        this.isModel2Visible = false;
        this.selectedOption = '';
        this.selectedTherapistType = ''
        this.pack = undefined;
        this.resetSessionSchedulingState()
        this.fetchPacksSubscription();
      },
      error: (err) => {
        const errorBody = err.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody?.description);
        // The transfer may already have gone through (e.g. only the feedback
        // email failed), so don't leave the modal open for a second attempt.
        this.isModel2Visible = false;
        this.selectedOption = '';
        this.selectedTherapistType = '';
        this.pack = undefined;
        this.resetSessionSchedulingState();
        this.fetchPacksSubscription();
      },
    });
  }

  onSelectedTherapistOptionChange(id: string) {
    this.selectedOption = id;
    const t = this.therapist.find((x) => x.id === id);
    this.newTherapistEmail = t?.email || '';
    this.checkBoxTimeRangeOptions = [];
    this.selectedSessionDate = undefined;
    this.selectedSessionTime = undefined;
    this.sessionOkDisabled = true;
  }

  onNewPackSessionDateChange($event: Date) {
    if (!moment($event).startOf('day').isSameOrAfter(moment().startOf('day'))) {
      this.toastService.showError('Date should be in future');
      return;
    }
    this.selectedSessionDate = $event;
    this.selectedSessionTime = undefined;
    this.sessionOkDisabled = true;
    const request = {
      therapistId: this.selectedOption || '',
      date: moment($event).format('x'),
    };
    this.therapistService.getTimeRangesForSelectedDay(request).subscribe({
      next: (therapistTimeSlots) => {
        this.checkBoxTimeRangeOptions = [];
        therapistTimeSlots.forEach((timeSlot: TimeRangesResponse) => {
          if (!timeSlot.notAvailableSlotExists) {
            this.checkBoxTimeRangeOptions.push({
              label: `${timeSlot.start} - ${timeSlot.end}`,
              value: timeSlot,
              checked: false,
              disabled: !timeSlot.available,
            });
          }
        });
        this.sessionOkDisabled = true;
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  onNewPackSessionTimeChange($event: TimeRangesResponse[]) {
    if ($event && $event.length > 0) {
      this.selectedSessionTime = moment($event[0].start, 'hh:mm a').toDate();
      this.sessionOkDisabled = !(this.selectedSessionDate && this.selectedSessionTime);
    }
  }

  onPackCheckboxClick($event: boolean, selectedIndex: number) {
    this.checkBoxTimeRangeOptions.forEach((option, index) => {
      option.checked = index === selectedIndex;
    });
  }

  onTransferConfirmedPackToggle(val: boolean) {
    this.transferConfirmedSessions = val;
  }


  selectedConcern: string = '';
  selectedExpertise: string = '';
  selectedAuxTherapist: string = '';
  onUpdateTherapist(pack: AnyoPacksSubscriptionResponse) {
    this.therapistOptions = [];
    this.pack = pack;
    this.isModel3Visible = true;
    this.therapist.map((data) => {
      this.therapistOptions.push({
        label: getFullName(data.firstName, data.lastName),
        value: data.id!,
      });
    });
  }

  onExpertiseChange($event: string) {
    this.therapistOptions = [];
    this.therapist.map((data) => {
      if (
        data.packExpertiseDetails?.some(
          (pack) =>
            pack.packId === this.pack!.packId && pack.expertiseId === $event,
        )
      ) {
        this.therapistOptions.push({
          label: getFullName(data.firstName, data.lastName),
          value: data.id!,
        });
      }
    });
  }

  handleChangeAuxTherapist() {
    const req: AdminChangeAuxTherapistAndCencernRequest = {
      packSubscriptionId: this.pack!.packSubscriptionId,
      newTherapistId: this.selectedAuxTherapist,
      concernId: this.selectedConcern,
      newExpertiseId: this.selectedExpertise,
    };
    this.packService.adminChangeAuxTherapist(req).subscribe({
      next: () => {
        this.toastService.showSuccess(
          'Auxiliary Therapist changed successfully!',
        );
        this.isModel3Visible = false;
        this.selectedAuxTherapist = '';
        this.selectedExpertise = '';
        this.pack = undefined;
        this.fetchPacksSubscription();
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }
}
